var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.type,"value":!!_vm.error}},[_vm._v(_vm._s(_vm.error))])
}
var staticRenderFns = []

export { render, staticRenderFns }